import MockableSecureIdentityProviderImplementation from './mockableSecureIdentityProviderImplementation';
import SecureIdentityProvider, {
  QrCodeResult,
  DeepLinkResult,
  ScopeRequestResult,
  ScopeRequestStatusResult,
} from './secureIdentityProvider';
import SecureIdentityProviderImplementation from './secureIdentityProviderImplementation';
import { ScopeRequest, QrCodeTheme, ScopeRequestStatus } from './types';

const isE2e =
  (process.env.REACT_APP_STAGE || 'unknown') === 'e2e' || (process.env.REACT_APP_STAGE || 'unknown') === 'preprod_e2e';
const sip: SecureIdentityProvider = isE2e
  ? new MockableSecureIdentityProviderImplementation()
  : new SecureIdentityProviderImplementation();

export default sip;

export { ScopeRequestStatus, QrCodeTheme };
export type { ScopeRequest, QrCodeResult, DeepLinkResult, ScopeRequestResult, ScopeRequestStatusResult };
